import { Component, ViewChild, OnInit } from '@angular/core';
import { DashboardService } from '../../../../../service/events/dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseForm } from '../../../../base-form';
import { VentasApiService } from '../../../../../service/api/ventas-api.service';
import { RequestButtonComponent } from 'src/app/common/components/request-button/request-button.component';
import { environment } from 'src/environments/environment';

import { Compradores } from 'src/app/models/ventas/compradores.model';
import { CompradoresFormDefinition } from './form-definition';
import { EventPhase, FormPhase, ReactiveFormRequestCoordinator } from '@fitogest/reactive-form-builder/form-request';
import { ReactiveFormChangedField, ReactiveFormValue } from '@fitogest/reactive-form-builder/interfaces';
import { setDropdownSelected } from '@fitogest/reactive-form-builder/utils';

@Component({
    selector: 'app-compradores-form',
    standalone: false,
    templateUrl: './compradores-form.component.html',
    styleUrls: ['./compradores-form.component.scss']
})
export class CompradoresFormComponent extends BaseForm<Compradores> implements OnInit {

    @ViewChild(RequestButtonComponent, { read: RequestButtonComponent, static: true })
    requestButton = new RequestButtonComponent<Compradores>();

    public form!: CompradoresFormDefinition;

    public formRequest = new ReactiveFormRequestCoordinator<Compradores>;

    public override model: Compradores = {} as Compradores;


    constructor(public override dashboard: DashboardService,
        public override router: Router,
        public override route: ActivatedRoute,
        public ventasApi: VentasApiService
    ) {
        super(
            route,
            router,
            dashboard,
            ventasApi.compradoresPUT,
            ventasApi.compradoresPOST,
            'compradores',
            'Actualizar ' + environment.features.comercioName,
            'Crear ' + environment.features.comercioName
        );

                this.form = new CompradoresFormDefinition(
                    this.getType(),
                    this.getModel() as unknown as Record<string, string>,
                    null
                );
    }

    ngOnInit() {
        this.formRequest.addEvent(FormPhase.LOAD, EventPhase.AFTER, (resolve) => {
            setDropdownSelected(this.form.lists.tipos, 'Proveedor');
            this.form.model.tipo = 'Proveedor';
            resolve(true);
        });

        this.softInit(this.getType());
    }

    public formChanges(formModel: ReactiveFormValue<Compradores>, lastChangedFieldName: ReactiveFormChangedField<Compradores>): void {
        this.form.model = formModel;
        this.form.tag = lastChangedFieldName;
    }// ();
}// class;
